<template>
  <div class="row jipvio-dashboard">
    <div class="col-12">
      <card
        class="mt-50 pl-30 pr-50"
        card-body-classes="table-full-width"
        no-footer-line
      >
        <h2 class="ftitle jipvio-color4">찜한매물</h2>
        <div class="F_Menu pl-15">
          <ul class="F_Menu_Select Menuline row px-0 mb-0">
            <li v-for="btn in selects.BPP" :key="btn.value">
              <el-radio
                v-model="btnRadio1"
                :label="btn.label"
                border
                @click="ctrTypeSelect = btn.value"
                >{{ btn.label }}</el-radio
              >
            </li>
          </ul>
          <!-- <ul class="F_Menu_Select Menuline row px-0 mb-0">
            <li><el-button round @click="Apart(APT)">아파트</el-button></li>
            <li><el-button round>빌라</el-button></li>
            <li><el-button round>주택</el-button></li>
            <li><el-button round>오피스텔</el-button></li>
            <li><el-button round>원룸</el-button></li>
          </ul> -->
          <ul class="F_Menu_Select row  px-0 mr-0 mb-0">
            <li v-for="btn in selects.PTT" :key="btn.value">
              <el-radio
                v-model="btnRadio2"
                :label="btn.label"
                border
                @click="bldTypeSelect = btn.value"
                >{{ btn.label }}</el-radio
              >
            </li>
            <!-- <li><el-button round>전세</el-button></li> -->
            <!-- <li><el-button round>월세</el-button></li> -->
            <li class="jipvio-color4 totalCnt">
              전체 {{ pagination.totalCnt }}개
            </li>
          </ul>
        </div>
        <div>
          <div class="row col-5 px-0 ml-0 mr-0 ">
            <!-- <div
              class="col-lg-6 px-0 mb-2 MP5pptImgBox"
              v-for="pl in propertyList"
              :key="pl.propId"
            > -->
            <!-- {{ pl.propId }} -->
            <div
              class="SRpptImgBox MP5pptImgBox"
              v-for="(pl, index) in propertyList"
              :key="pl.propId"
            >
              <!-- <img class="SRpptImg" :src="pl.imgUrl" /> -->
              <img class="SRpptImg" :src="previewUrl[index]" />
              <div class="like_btn">
                <i
                  class="fas fa-heart"
                  @click="removeLike(index, pl.propId)"
                ></i>
              </div>
              <div class="SRoverlay ft-18">
                <p>
                  {{
                    pl.type != null
                      ? sessionCoCodeMapDetail.BPP[pl.type].name
                      : ""
                  }}
                </p>
                <h5 class="SRpptImgH6">전세 {{ depositH(index) }}</h5>
                <p>
                  <strong>면적</strong> {{ pl.useArea }}㎡
                  <strong>방/욕실</strong> {{ pl.roomCnt }} /
                  {{ pl.wroomCnt }}
                </p>

                <div class="T_none">
                  <i class="fl">-</i>
                  <p class="fl">
                    {{ pl.addr }}<br />
                    {{ pl.newAddr }}
                  </p>
                </div>
                <!-- <h6 class="SRpptImgH6" style="width:100%;">id {{ pl.propId }}</h6> -->
                <!-- <el-button @click="toDetailPage(pl.propId)">자세히보기</el-button> -->
                <button
                  class="jipvio-bg-color1"
                  @click="toDetailPage(pl.propId)"
                  style="cursor: pointer"
                >
                  자세히 보기
                </button>
              </div>
            </div>
            <!-- <img class="MP5pptImg" :src="pl.imgUrl" />
                      < <div class="MP5overlay">
                        <h6 class="MP5pptImgH6">id {{ pl.propId }}</h6>
                        <el-button>자세히보기</el-button>
                      </div> -->
            <!-- </div> -->
          </div>
          <n-pagination
            class="pagination-no-border"
            style="justify-content:center"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.totalCnt"
          >
          </n-pagination>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Select,
  Option,
  Input,
  Button,
  Radio,
  Popover,
  MessageBox,
  Message
} from "element-ui";
import { Pagination as NPagination } from "@/components";
import { Button as NButton } from "@/components";
import card from "@/components/Cards/Card.vue";
import propApi from "@/service/property";
import filestoreApi from "@/service/filestore";

import { createNamespacedHelpers } from "vuex";

const {
  mapGetters: sessionMapGetters,
  mapActions: sessionMapActions
} = createNamespacedHelpers("loginSession");

export default {
  components: {
    NPagination,
    NButton,
    card,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Input.name]: Input,
    [MessageBox.name]: MessageBox,
    [Button.name]: Button,
    [Radio.name]: Radio
  },
  created() {
    console.log("======찜한매물");
    this.applyCommonCode();
    this.getAllPropertyLike();
  },

  computed: {
    ...sessionMapGetters({
      sessionCoCodeMap: "getCoCodeMap",
      sessionUserInfo: "getUserInfo",
      sessionCoCodeMapDetail: "getCoCodeMapDetail"
    }),
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.totalCnt;
    }
  },
  data() {
    return {
      btnRadio1: "",
      btnRadio2: "",

      bldTypeSelect: null,
      ctrTypeSelect: null,
      /* test(데이터 생기면 삭제) */
      previewUrl: [
        "http://192.168.0.86/ic/OlwqSf-vYuMoBs8j5XVcS5aFglMs5r-4cLQ4zIJAX3sUN3av6DVP9FqoJYMzjdVa.jpg",
        "http://192.168.0.86/ic/lCLDX4R7duM86OkSLn9U-MnjrhJwSf8VVaqlqJuL8Ng=.jpg",
        "http://192.168.0.86/ic/NozNKsmv5rsCyBSGoA5Vqwv30VQ602YnUQZIzhPP44A=.jpg",
        "http://192.168.0.86/ic/PUL8qeeUEtP-e1UJC-GvjMHrvQC9E_i2YMWnTIs-MGi-arB-nbSlhjeb37HeTlS4.jpg"
      ],

      selects: {
        BPP: [], // 건물종류
        PTT: [] //거래유형
      },

      propertyList: [],
      pagination: {
        perPage: 4,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        totalCnt: 0,
        totalPages: 10
      }
    };
  },
  methods: {
    applyCommonCode() {
      //BPP========================================================
      this.sessionCoCodeMap.BPP.forEach((ele, dex) => {
        this.selects.BPP.push({
          value: ele.code,
          label: ele.name
        });
      });

      //PTT========================================================
      this.sessionCoCodeMap.PTT.forEach((ele, dex) => {
        this.selects.PTT.push({
          value: ele.code,
          label: ele.name
        });
      });
    },

    async getAllPropertyLike() {
      const pagingReq = {
        pageNo: this.pagination.currentPage - 1,
        sizePerPage: this.pagination.perPage
        // typeList: this.bldTypeSelect,
        // paymentTypeList: ctrTypeSelect,
      };

      const res = await propApi.getAllPropertyLike(pagingReq);
      console.log("pptLikeeeeeeee");
      console.log(res);
      this.pagination.perPage = res.pagingInfo.size;
      this.pagination.currentPage = res.pagingInfo.pageNo + 1;
      this.pagination.totalCnt = res.pagingInfo.totalCnt;
      this.pagination.totalPages = res.pagingInfo.totalPages;

      this.propertyList = res.payload;
      // console.log("======================property");
      // console.log(this.propertyList);
    },

    removeLike(idx, propId) {
      let self = this;
      console.log("removeAPi");
      MessageBox.confirm("정말로 삭제하시겠습니까?", "Warning", {
        confirmButtonText: "네",
        cancelButtonText: "아니요",
        type: "warning"
      })
        .then(async () => {
          const res = await propApi.removeUserLikeProperty(propId);
          if (res.status === 200) {
            self.propertyList[idx].isFavorite = !self.propertyList[idx]
              .isFavorite;
            self.getAllPropertyLike();
            console.log("remove");
          }
        })
        .catch(() => {
          console.log("fail");
          return;
        });
    },

    toDetailPage(value) {
      this.$router.push({
        path: "/prop/detail",
        query: { id: value }
      });
    },

    depositH(i) {
      console.log("ddddsesse");
      const depositVal =
        this.propertyList[i].deposit < 0 ? false : this.propertyList[i].deposit;
      const unitWords = ["원", "만원", "억", "조", "경"];
      const splitUnit = 10000;
      const splitCount = unitWords.length;
      let resultArray = [];
      let resultString = "";

      for (let i = 0; i < splitCount; i++) {
        let unitResult =
          (depositVal % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i);
        unitResult = Math.floor(unitResult);
        if (unitResult > 0) {
          resultArray[i] = unitResult;
        }
      }
      for (var i = 0; i < resultArray.length; i++) {
        if (!resultArray[i]) continue;
        resultString = String(resultArray[i]) + unitWords[i] + resultString;
      }

      return resultString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  mounted() {},
  watch: {
    "pagination.currentPage"(newValue, oldValue) {
      this.getAllPropertyLike();
    },
    "pagination.perPage"(newValue, oldValue) {
      this.pagination.currentPage = 1;
      this.getAllPropertyLike();
    }
  }
};
</script>
<style>
.MP5pptImgBox {
  position: relative;
}

.MP5pptImgBox:hover .MP5overlay {
  opacity: 1;
}

.MP5pptImg {
  width: 90%;
  margin: auto;
}

.MP5overlay {
  position: absolute;
  top: 0;
  left: 5%;
  /* background: rgb(0, 0, 0); */
  background: rgba(0, 0, 0, 0.5); /* Black see-through */
  width: 90%;
  height: 100%;
  color: #f1f1f1;
  transition: 0.5s ease;
  opacity: 0;
  color: white;
  font-size: 20px;
  text-align: center;
  z-index: 999;
  padding-top: 5%;
}

.MP5pptImgH6 {
  color: white;
}

.ftitle {
  margin-top: 45px;
  font-size: 24px;
  line-height: 33px;
}

.F_Menu .F_Menu_Select {
  padding: 16px 0;
  font-size: 1em;
  position: relative;
}
.F_Menu .Menuline::after {
  content: "";
  width: 100%;
  height: 1px;
  background-color: rgba(39, 39, 39, 0.17);
  position: absolute;
  bottom: 0;
}

.F_Menu .F_Menu_Select li {
  list-style-type: none;
  margin-right: 19px;
}

.F_Menu .F_Menu_Select .totalCnt {
  position: absolute;
  right: 10px;
}

.SRpptImgBox {
  position: relative;
  margin: 15px 0 15px 15px;
  width: 13.83vw;
  height: 13.83vw;
}
.SRpptImgBox .SRpptImg {
  position: absolute;
  object-fit: cover;
  height: 100%;
}
.SRpptImgBox:hover .SRoverlay {
  opacity: 1;
}
.SRpptImgBox .SRoverlay {
  /* background: rgb(0, 0, 0); */
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Black see-through */
  position: absolute;
  padding: 16% 0 0 8%;
  transition: 0.5s ease;
  opacity: 0;
  color: #fff;
  text-align: center;
  z-index: 99;
}
.SRpptImgBox .SRoverlay:hover {
  opacity: 1;
}
.SRoverlay .SRpptImgH6,
.SRpptImgBox .SRoverlay p {
  color: #fff;
  width: 80%;
  line-height: 1.3em;
  text-align: left;
}
.SRpptImgBox .SRoverlay .SRpptImgH6 {
  font-size: 1vw;
}
.SRpptImgBox .SRoverlay p:nth-of-type(1) {
  font-size: 0.7vw;
}
.SRpptImgBox .SRoverlay p:nth-of-type(2) {
  font-size: 0.85vw;
}
.SRpptImgBox .SRoverlay button {
  width: 100%;
  height: 2.66vw;
  font-size: 1em;
  font-weight: bold;
  position: absolute;
  bottom: 0;
  left: 0;
  border: none;
  color: #fff;
}
.like_btn {
  position: absolute;
  top: 4%;
  right: 5%;
  z-index: 100;
  font-size: 25px;
  color: #fff;
  cursor: pointer;
}
</style>
